<!--The content below is only a placeholder and can be replaced.-->
<div id="chart">
  <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
    [title]="chartOptions.title"></apx-chart>
</div>
